import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchConsentTrials = async () => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/appiell/consent_trial/`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useConsentTrials = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["consent_trial"],
    queryFn: () => fetchConsentTrials(),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export default useConsentTrials;
